import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/sections/Hero';
import WorkIndex from '../components/sections/WorkIndex';
import About from '../components/sections/About';
import Parcours from '../components/sections/Parcours';
import Contact from '../components/sections/Contact';
import Marquee from '../components/motion/Marquee';
import { useReveal } from '../hooks/useReveal';

const MARQUEE_ITEMS = [
  'UX/UI Design',
  '<em>Figma</em>',
  'Intégration front-end',
  '<em>WordPress</em>',
  'Design d’interfaces',
  '<em>Angers</em>'
];

const Home = () => {
  const location = useLocation();
  useReveal([location.pathname]);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <Marquee items={MARQUEE_ITEMS} />
      <WorkIndex />
      <About />
      <Parcours />
      <Contact />
    </main>
  );
};

export default Home;
